module.exports = __webpack_public_path__ + "img/checkbox-marked.1efd3b79.svg";